import { PlusOutlined } from "@ant-design/icons";
import { Handle, HandleProps, Position } from "@xyflow/react";

interface Props extends HandleProps {
    id: string;
    color: string;
}

export const CustomHandle = ({ color, id, position, onClick, ...props }: Props) => {
    return (
        <Handle
            id={id}
            position={position}
            {...props}
            style={{
                background: "transparent",
                border: "none",
                width: 65,
                height: 65,
                borderRadius: "50%",
                cursor: "pointer",
            }}
        >
            <div
                onClick={(e) => {
                    e.stopPropagation();
                    onClick?.(e);
                }}
                className={`relative flex items-center ${position === Position.Right ? "justify-end" : "justify-start"} w-full h-full`}
            >
                <div className="rounded-[50%] absolute inset-0 opacity-10 hover:opacity-20" style={{ backgroundColor: color }} />
                <PlusOutlined
                    className={`${position === Position.Right ? "mr-0.5" : "ml-0.5"}`}
                    style={{
                        color,
                    }}
                />
            </div>
        </Handle>
    );
};
